<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
      class="flex flex-col full-grow-no-shrink-no-basis">
  <span>
    {{toolTipText}}
  </span>
  <mat-form-field appearance="outline" class="flex-1-1-100">

    <mat-label [ngStyle]="titleStyle">
      {{fieldDefinition.header}}
      <i *ngIf="isFormMandatoryField()" class="fa-solid fa-m"></i>
    </mat-label>

    <!--<input formControlName="entityType" matInput placeholder="" required>-->
    <mat-select [errorStateMatcher]="errorMatcher" formControlName="value" (selectionChange)="onSelectionChange($event)"
                [disabled]="disabled">
      <mat-option *ngFor="let data of (dropdownData$|async)" [value]="data">
        {{data.text}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="inputFormError.value.required" class="text-truncate"
               matTooltip="{{fieldDefinition.header}} is required!">
      {{fieldDefinition.header}} is required!
    </mat-error>
    <mat-error *ngIf="inputFormError.value.customError" class="text-truncate"
               matTooltip="{{this.fieldDefinition.metaData['ErrorMessage']}}">
      {{this.fieldDefinition.metaData['ErrorMessage']}}
    </mat-error>
    <mat-hint
      *ngIf='fieldDefinition.instruction && fieldDefinition.instruction.length'>{{fieldDefinition.instruction}}</mat-hint>
  </mat-form-field>
</form>
